
          <!-- messaggi di errore visibili solamente se l'utente ha interagito con il campo -->
          <div class="" *ngIf="fireInvalidSubmit && form && validation">
            <!-- messaggio errore obbligatorio -->
            <span class="input-error-notification" *ngIf="form.controls[validation.name].errors?.required">{{ validation.message.nullable }}</span>
            <!-- messaggio errore minimo numero di caratteri (string), oppure minimo valore (number) -->
            <span class="input-error-notification" *ngIf="(form.controls[validation.name].errors?.minlength || form.controls[validation.name].errors?.min)">{{ validation.message.min }}</span>
            <!-- messaggio errore massimo numero di caratteri (string), oppure massimo valore (number) -->
            <span class="input-error-notification" *ngIf="(form.controls[validation.name].errors?.maxlength || form.controls[validation.name].errors?.max)">{{ validation.message.width }}</span>

            <!-- messaggio errore violazione validatore phone_mg -->
            <span class="input-error-notification"
            *ngIf="form.controls[validation.name].errors?.phone_mg ||
            form.controls[validation.name].errors?.phone ||
            form.controls[validation.name].errors?.email ||
            form.controls[validation.name].errors?.latitude ||
            form.controls[validation.name].errors?.longitude ||
            form.controls[validation.name].errors?.fiscalCode ||
            form.controls[validation.name].errors?.number ||
            form.controls[validation.name].errors?.numberNotNegative ||
            form.controls[validation.name].errors?.integerNotNegative ||
            form.controls[validation.name].errors?.decimal2NotNegative ||
            form.controls[validation.name].errors?.ipAddress
            ">
            {{ 'validationMsg.invalidFormat' | translate }}
          </span>

          <!-- messaggio errore CAP non valido -->
          <span class="input-error-notification" *ngIf="form.controls[validation.name].errors?.zipCode">{{ 'validationMsg.invalidZipCode' | translate }}</span>

          </div>



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/validation-msg/validation-msg.component.html